import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const isEnableLoadingAbsenceSelector = createSelector(
  (state: RootState) => state.attendContact,
  (item) => item.nextTokenAbsence !== '',
);

export const isEnableLoadingLateSelector = createSelector(
  (state: RootState) => state.attendContact,
  (item) => item.nextTokenLate !== '',
);

export const isEnableLoadingLeaveEarlySelector = createSelector(
  (state: RootState) => state.attendContact,
  (item) => item.nextTokenLeaveEarly !== '',
);
